<template>
  <div class="dashboard-editor-container" style="margin-top:20px;">
    Sorry! Page in development.
  </div>
</template>

<script>
export default {
  name: 'DashboardAdmin',
  components: {

  },
  data() {
    return {

    }
  },
  mounted() {

  },
  created() {
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
